import axios from "axios";
import Url from "./Url";

var apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
const client = axios.create();
const ignoreTokenList = [Url.NOC.GET_DEPT, Url.Login.SEND_OTP, Url.NOC.GET_NOC_PASS,Url.NOC.SAVE_NOC, Url.Login.CAPTCHA,Url.DOC.UPLOAD_FILE]
client.interceptors.request.use(
  (requestConfig) => {
      var url = requestConfig.url;
      var ignoreFlag = false;
      ignoreTokenList.forEach((ignoreTokenUrl) => {
        // console.log("IgnoreUrl " , ignoreTokenUrl , "Actual URL " , requestConfig.url);
        if(requestConfig.url.indexOf(ignoreTokenUrl) > 0 ){
          ignoreFlag = true;
        }
      })
      if(!ignoreFlag){
        let authString = "Bearer " + sessionStorage.getItem("token");
        requestConfig.headers["Authorization"] = authString;
      }
      requestConfig.headers["client-origin-key"] = "ahct-hmfs";
      requestConfig.headers["client-origin-id"] = "a#27dv*s*sbs!cgrf-9x@1w3";
    
      return requestConfig;
  },
  (requestError) => {
      console.log(requestError);
      return Promise.reject(requestError);
  }
);


const ApiClient={
    async get(url)
    {
        const response = await client.get(apiBaseUrl + url);
        return response.data 
            
    },
    download(url,fileId)
    {
        return apiBaseUrl +  url + fileId;
    },
    async post(url,data)
    {
       const response = await client.post(apiBaseUrl + url, data);
       return response.data;     
    },
    async fileUpload(url,formData)
    {
      try{
        const response = await client.post(apiBaseUrl + url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        return response.data;
      }
      catch{
        alert("File format or size is not correct");
      }
           
    },
    
}

export default ApiClient;

